import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { FacilityDTO } from "../Facility";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { FacilityService } from "../facility.service";
import { SessionService } from "src/app/session.service";
import { NotificationService } from "src/app/notifications/notification.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "src/app/shared/dialogs/filter-table-dialog/filter-table-dialog.component";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { UiService } from "src/app/ui/ui.service";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { BehaviorSubject, merge, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  first,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { DataSource } from "@angular/cdk/table";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { CollectionViewer } from "@angular/cdk/collections";
import { FormControl } from "@angular/forms";
import { LocalStorageService } from "src/app/storage/local-storage.service";

@Component({
  selector: "app-facilities-list",
  templateUrl: "./facilities-list.component.html",
  styleUrls: ["./facilities-list.component.scss"],
})
export class FacilitiesListComponent implements OnInit {
  pageSizeOptions = pageSizeOptions;
  searchValueControl = new FormControl("");
  facilities!: FacilityDTO[];
  perPage: number = 20;

  columns = [
    { code: "id", name: "ID" },
    { code: "name", name: "Facility Name", filter: true, selected: true },
    { code: "address1", name: "Address", filter: true, selected: true },
    { code: "city", name: "City", filter: true, selected: true },
    { code: "state", name: "State", filter: true, selected: true },
    { code: "zip", name: "Zip", filter: true, selected: true },
    { code: "floors", name: "Floors" },
    { code: "options" },
  ];
  displayedColumns = this.columns.map((column) => column.code);

  @ViewChild("facilitiesTable") facilitiesTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  hasFacilitiesWrite: boolean = false;
  hasFacilitiesDetail: boolean = false;
  private onComponentDestroy = new Subject();
  @ViewChild(ElementLoaderDirective)
  facilityElementLoader!: ElementLoaderDirective;
  facilitiesDataSource!: FacilitiesDataSource;
  onFilterColumnChange = new Subject();

  constructor(
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private FacilityService: FacilityService,
    private SessionService: SessionService,
    private NotificationService: NotificationService,
    private uiService: UiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private localStorageSvc: LocalStorageService,
  ) {}

  ngOnInit(): void {

    this.perPage = this.localStorageSvc.pageSize || 20;

    // this.facilities = this.activatedRoute.snapshot.data.facilities.records;
    // this.facilityDataSource = new MatTableDataSource(this.facilities);

    // this.facilityDataSource.filterPredicate = (data: any, filter: string) => {
    //   let found = false;
    //   for (let column of this.selectedColumns) {
    //     let rowValue = data[column];
    //     if (typeof rowValue === "number") {
    //       rowValue = rowValue.toString();
    //     }
    //     if (typeof rowValue === "string") {
    //       if (rowValue?.trim().toLowerCase().indexOf(filter) !== -1) {
    //         found = true;
    //       }
    //     }
    //   }

    //   return found;
    // };

    this.hasFacilitiesWrite =
      this.activatedRoute.snapshot.data.permissions.hasFacilitiesWrite;

    this.hasFacilitiesDetail =
      this.activatedRoute.snapshot.data.permissions.hasFacilitiesDetail;
  }

  ngAfterViewInit() {
    // this.facilitiesTable.renderRows();
    // this.facilityDataSource.sort = this.sort;
    // this.facilityDataSource.paginator = this.paginator;
    this.facilitiesDataSource = new FacilitiesDataSource(
      this.FacilityService,
      this.paginator,
      this.facilityElementLoader,
    );

    this.loadFacilitiesPage().pipe(first()).subscribe();

    merge(
      this.sort.sortChange.pipe(tap(() => (this.paginator.pageIndex = 0))),
      this.paginator.page,
      this.onFilterColumnChange,
      this.searchValueControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
      ),
    )
      .pipe(
        debounceTime(300),
        switchMap(() => this.loadFacilitiesPage().pipe(first())),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe();

    this.ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue;
  }

  applyFilter() {
    // this.facilityDataSource.filter = this.searchValue.trim().toLowerCase();
  }

  createNewFacility() {
    this.router.navigate(["create"], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  toggleFilterDialog() {
    this.dialog
      .open(FilterTableDialogComponent, {
        data: {
          columns: this.columns,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.columns = result;
          this.onFilterColumnChange.next();
        }
      });
  }

  edit(facility: FacilityDTO) {
    this.router.navigate([facility.id], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  delete(facility: FacilityDTO) {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this facility ( ${facility.name} )?`,
            warning: "Warning: this is not reversible!",
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.uiService
            .waitForEvent(
              this.FacilityService.deleteFacility(
                this.currentAccount!.accountID,
                facility.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar("Facility deleted");
                this.loadFacilitiesPage().pipe(first()).subscribe();
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting facility",
                );
              },
            );
        }
      });
  }

  loadFacilitiesPage() {
    const sort = this.buildSort();

    return this.facilitiesDataSource.loadFacilities(
      this.SessionService.currentAccountValue!.accountID,
      {
        page: this.paginator.pageIndex,
        perPage: this.paginator.pageSize,
        keyword: this.searchValueControl.value ?? "",
        forCount: true,
        sort,
        filter_columns: this.columns
          .filter((column) => column.selected)
          .map((column) => column.code),
      },
    );
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      sort.push(`${this.sort.active}:${this.sort.direction}`);
    }
    return sort;
  }

  onPageChange(e: PageEvent){
    this.localStorageSvc.pageSize = e.pageSize;
    this.perPage = e.pageSize;
  }
}

export class FacilitiesDataSource implements DataSource<any> {
  private facilitiesSubject = new BehaviorSubject<any[]>([]);

  constructor(
    private FacilityService: FacilityService,
    private paginator: MatPaginator,
    private facilitiessElementLoader: ElementLoaderDirective,
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.facilitiesSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.facilitiesSubject.complete();
  }

  loadFacilities(masterAccountID: number, queryParams: any) {
    return this.facilitiessElementLoader
      .waitForEvent(
        this.FacilityService.getFacilities(masterAccountID, queryParams).pipe(
          catchError(() => of({ count: 0, records: [] })),
        ),
      )
      .pipe(
        tap((filter: any) => {
          this.paginator.length = filter.count;
          const records = filter.records;
          this.facilitiesSubject.next(records);
        }),
      );
  }
}
